import { DataNotFound } from '../../../CommonComponents/DataNotFound';


const ECONBasic = () => {

    return (
        <DataNotFound />
    );
};

export default ECONBasic;
